import { render, staticRenderFns } from "./AccountHome.vue?vue&type=template&id=4b473282"
import script from "./AccountHome.vue?vue&type=script&lang=js"
export * from "./AccountHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports